import React from "react";
import { FaBars } from "react-icons/fa";
import Image from "../../images/logo.jpg";
import PlFlag from "../../images/poland.png";
import EnFlag from "../../images/united-kingdom.png";
import { Link } from "react-router-dom";
import {
  Nav,
  NavBarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  NavLinks,
  NavLogoImg,
  ImageButton1,
  ImageButton2,
} from "./NavBarElementsEN";

const NavBarEN = ({ toggle }) => {
  return (
    <>
      <Nav>
        <NavBarContainer>
          <NavLogo
            to="startEN"
            smooth={true}
            duration={500}
            spy={true}
            exact={true}
            offset={-80}
          >
            <NavLogoImg src={Image} type="image/jpg" />
            ETS Peaks for Caps
          </NavLogo>
          <MobileIcon onClick={toggle}>
            <FaBars />
          </MobileIcon>
          <NavMenu>
            <NavItem>
              <NavLinks
                to="aboutEN"
                smooth={true}
                duration={500}
                spy={true}
                exact={true}
                offset={-75}
              >
                About Us
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks
                to="offerEN"
                smooth={true}
                duration={500}
                spy={true}
                exact={true}
                offset={-70}
              >
                Offer
              </NavLinks>
            </NavItem>
            <NavItem>
              <NavLinks
                to="contactEN"
                smooth={true}
                duration={500}
                spy={true}
                exact={true}
                offset={-70}
              >
                Contact
              </NavLinks>
            </NavItem>
            <NavItem>
              <Link to="/">
                <ImageButton1 src={PlFlag} type="image/png" />
              </Link>
              <Link to="/en">
                <ImageButton2 src={EnFlag} type="image/png" />
              </Link>
            </NavItem>
          </NavMenu>
        </NavBarContainer>
      </Nav>
    </>
  );
};

export default NavBarEN;
